// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Actions from "../../../../actions/businessFields";
import ModalForm from "./Form";

class BusinessFieldModal extends Component {
  onSave = () => {
    if (this.props.businessField.id) {
      this.props
        .dispatch(Actions.onUpdate(this.props.businessField.id))
        .then(() => {
          this.props.dispatch(Actions.fetchBusinessFields());
        });
    } else {
      this.props.dispatch(Actions.onCreate()).then(() => {
        this.props.dispatch(Actions.fetchBusinessFields());
      });
    }
  };

  onCancel = () => {
    this.props.dispatch(Actions.onToggleVisible());
  };

  onChangeName = e => {
    this.props.dispatch(Actions.onChangeName(e.target.value));
  };

  

  render() {
    const { isLoading, businessField, isModalVisible } = this.props;
    return (
      <ModalForm
        isLoading={isLoading}
        visible={isModalVisible}
        businessField={businessField}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onChangeName={this.onChangeName}
        destroyOnClose
      />
    );
  }
}

BusinessFieldModal.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  businessField: PropTypes.object,
  isLoading: PropTypes.bool,
  errors: PropTypes.bool
};

const mapStateToProps = state => ({
  isLoading: state.businessFields.isLoading,
  isModalVisible: state.businessFields.isModalVisible,
  errors: state.businessFields.errors,
  businessField: state.businessFields.businessField
});

export default connect(mapStateToProps)(withRouter(BusinessFieldModal));
